/**
 * 奖励&成就
 * auth：xuyan
 * time：2023-06-13 18:57
 */

import classnames from 'classnames';
import { useState, useMemo, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useRecoilState,
  useRecoilCallback,
  useRecoilValueLoadable,
  useRecoilRefresher_UNSTABLE,
  useSetRecoilState,
} from 'recoil';
import './index.scss';
import html2canvas from 'html2canvas';
import { fetchReward } from '@/models/userState';
import { produce } from 'immer';
import { Toast } from 'antd-mobile';
import { ShareText } from '@/utils/setting';
import { LayoutDesktop } from '@/components/LayoutPC/LayoutDesktop';
import { HonorsInfoModel } from '@/models/typing';
import { fetchHonorsInfoState, honorsInfoState, medalRenewedState } from '@/models/honorsState';
import ErrorPage from '@/components/Error';
import { DefaultLoadingPage } from '@/components/Loading';
import { Tracking } from '@/utils/tracking';
import { SpinLoading } from 'antd-mobile';

const RewardBox = (props: any) => {
  return (
    <div className={classnames('rewardBox')}>
      <div className='bg'>
        <div
          className={classnames('rewardBox-top', props.medal && 'medal')}
        ></div>
        <div
          className={classnames('rewardBox-mid', props.medal && 'medal')}
        ></div>
        <div
          className={classnames('rewardBox-btm', props.medal && 'medal')}
        ></div>
      </div>
      {props.children}
    </div>
  );
};

const HonorsPage = () => {
  const navigate = useNavigate();
  const [activityInfo, setActiveInfo] = useRecoilState(honorsInfoState);
  // const [activityInfo, setActiveInfo] = useRecoilState(activityInfoState);

  const [sharetext, setText] = useState(ShareText());

  const achieveList = useMemo(() => {
    return activityInfo.achieve_list;
  }, [activityInfo]);

  const rewardList = useMemo(() => {
    return activityInfo.reward_list;
  }, [activityInfo]);

  const alone: any = useMemo(() => {
    return activityInfo.achieve_list[0];
  }, [activityInfo]);

  const [imgUrl, setImgUrl] = useState('');

  const getShareImageBase64 = (imgDoc: any) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        html2canvas(imgDoc, {
          useCORS: true,
          scale: window.devicePixelRatio < 3 ? window.devicePixelRatio : 2,
          allowTaint: true,
          height: imgDoc.scrollHeight,
          windowHeight: imgDoc.scrollHeight,
          backgroundColor: '#0e0800',
        }).then((canvas: any) => {
          console.log('%cindex.tsx line:56 canvas', 'color: #007acc;', canvas);
          const imgData = canvas.toDataURL('image/jpeg', 1.0);
          resolve(imgData);
        });
      }, 300);
    });
  };

  const handleClose = () => {
    setImgUrl('');
  };

  const [selected, setShareIndex] = useState(-1); //成就图选择状态
  const [isload, setLoad] = useState(false); //海报生成loading

  const [navId, setNavId] = useState(0); //侧边栏状态

  const handleSlectedShare = (index: any) => {
    if (achieveList[index]?.status == '0') return;
    setShareIndex(index);
  };

  const selectImg: any = useMemo(() => {
    return achieveList[selected]?.img;
  }, [selected]);

  //点击成就图分享
  const handleShare = () => {
    if (isload) return;
    if (selected == -1) return Toast.show({ content: '请选择成就图' });
    Tracking.UP('click_all_answer_glory_share_button');
    setText(ShareText());
    setLoad(true);
    let ss = document.querySelector('#shareImage');
    getShareImageBase64(ss)
      .then((res: any) => {
        console.log('%cindex.tsx line:92 res', 'color: #007acc;', res);
        setImgUrl(res);
        setLoad(false);
      })
      .catch((error) => {
        console.log('%cindex.tsx line:69 error', 'color: #007acc;', error);
      });
  };

  //点击领奖
  const handleGetReward = useRecoilCallback(
    ({ snapshot }) =>
      async (list: any, index: number) => {
        try {
          if (list.status == 1) return;
          const res: any = await snapshot.getPromise(
            fetchReward(list.reward_bag_id)
          );
          if (res?.code * 1 === 100000) {
            Tracking.UP(`click_all_answer_glory_getReward${index * 1 + 1}`);
            //领奖成功
            setActiveInfo(
              produce(activityInfo, (draftState) => {
                draftState.reward_list[index].status = '1';
              })
            );
          }
          res && Toast.show({ content: res?.msg });
        } catch (error: any) {
          Toast.show({ content: error });
        }
      },
    [activityInfo]
  );

  const rewardRender = () => {
    return (
      <div className='rewardTab  nav-cont' id='nav-1'>
        <div className='rewardTab-title'>游戏道具奖励</div>
        {rewardList?.map((item: any, index: number) => {
          return (
            <div key={index}>
              <RewardBox key={index}>
                <div className='rewardTab-content' key={'reward' + index}>
                  <div
                    className={classnames(
                      'rewardTab-content-title',
                      'title' + Number(index + 1)
                    )}
                  ></div>
                  <div className='rewardTab-content-rewards'>
                    {item.list?.map((iitem: any, iindex: number) => {
                      return (
                        <div
                          className='rewardTab-content-reward'
                          key={'reward_list' + iindex}
                        >
                          <div className='pc-reward-box'>
                            <img src={iitem.img} alt='' />
                            <div></div>
                          </div>
                          <div>{iitem.title}</div>
                        </div>
                      );
                    })}
                  </div>
                  <div className='rewardTab-content-desc'>{item.title}</div>
                  <div
                    className={classnames(
                      'rewardTab-content-btn',
                      item.status == 1 && 'btn-got'
                    )}
                    onClick={() => handleGetReward(item, index)}
                  >
                    领取
                  </div>
                </div>
              </RewardBox>
            </div>
          );
        })}
        {/* <div className='rewardTab-title2'>勋章奖励</div> */}
      </div>
    );
  };

  const renderAchieve = () => {
    return (
      <div className='achievement' id='achievement'>
        <div className='achievement-title'></div>
        <img
          className='rewardTab-content2'
          src={require('../../../assets/img/reward-content3.png')}
          alt='\'
        />
        <div className='alone nav-cont' id='nav-2'>
          <div
            className={classnames(
              'achievement-list',
              alone?.status * 1 === 1 && 'unlock',
              0 == selected && 'selected'
            )}
            onClick={() => handleSlectedShare(0)}
          >
            <div className='achievement-list-pic'>
              {alone?.status * 1 === 1 && (
                <div className='achievement-list-pic__mask'></div>
              )}
              {alone?.status * 1 === 1 && <img src={alone?.img} alt='' />}
            </div>
            <div className='achievement-list-desc'>{alone?.title}</div>
          </div>
        </div>
        <div
          className={classnames(
            'achievement-lists',
            achieveList?.length < 5 && 'flex-lists'
          )}
        >
          {achieveList?.slice(1).map((item: any, index: number) => {
            return (
              <div
                key={index}
                className={classnames(
                  'achievement-list',
                  item.status * 1 === 1 && 'unlock',
                  index * 1 + 1 === selected && 'selected'
                )}
                onClick={() => handleSlectedShare(index + 1)}
              >
                <div className='achievement-list-pic'>
                  {item.status * 1 === 1 && (
                    <div className='achievement-list-pic__mask'></div>
                  )}
                  {item.status * 1 === 1 && <img src={item.img} alt='' />}
                </div>
                <div className='achievement-list-desc'>{item.title}</div>
              </div>
            );
          })}
        </div>
        <div className='achievement-btn'>
          <div className='achievement-back' onClick={() => navigate('/')}></div>
          <div className='achievement-share' onClick={handleShare}></div>
        </div>
      </div>
    );
  };

  const renderShare = () => {
    return (
      <div className='achieve-share-pc'>
        <div className='m-share share-canvas' id='shareImage'>
          <img
            className='share-canvas-logo'
            src={require('../../../assets/img/icon-colg.png')}
            alt=''
          />
          <div>
            <div className='m-share-achievePic'>
              <img src={selectImg || ''} alt='' />
              <div></div>
            </div>
            <div className='m-share-text'>
              <div className='text-left'>
                <div className='m-share-text__title'>COLG答题王活动</div>
                <div className='m-share-text__slogan'>{sharetext}</div>
              </div>
              <div className='img-qrcode'>
                <img
                  className='img-qrcode-mask'
                  src={`${require('../../../assets/img/qrcode-box.png')}`}
                  alt=''
                />
                <img
                  className='img-qrcode-code'
                  src='https://img-cos.colg.cn/uploads/image/colg_answer/bg_code/code.png/ori_png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>

        {/* {imgUrl && (
          <div>
            <div className='achieve-share-pop' onClick={handleClose}>
              <img className='shareCanvasImage' src={imgUrl} alt='' />
            </div>
          </div>
        )} */}
        {(isload || imgUrl) && (
          <div>
            <div className='achieve-share-pop' onClick={handleClose}>
              {imgUrl && (
                <img className='shareCanvasImage' src={imgUrl} alt='' />
              )}
              {isload && (
                <div className='achieve-share-pop-loading'>
                  <SpinLoading />
                </div>
              )}
            </div>
            {/* <img className='shareCanvasImageTop' src={imgUrl} alt='' /> */}
          </div>
        )}
      </div>
    );
  };

  //侧边栏

  const handlepageScroll = () => {
    let pageTop = document.documentElement.scrollTop;
    // let rewardTop: any = document.getElementById('nav-1')?.offsetTop;
    let achieveTop: any = document.getElementById('nav-2')?.offsetTop;
    achieveTop = achieveTop + document.getElementById('achievement')?.offsetTop;
    if (pageTop > achieveTop - 50) {
      setNavId(1);
    } else {
      setNavId(0);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handlepageScroll);
    return () => {
      window.removeEventListener('scroll', handlepageScroll);
    };
  }, []);

  const handleNavClick = (id: number) => {
    let name = 'nav-' + (id + 1);
    setNavId(id);
    document
      .getElementById(name)
      ?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  return (
    <LayoutDesktop>
      <div className='pc-honor'>
        <div className='pc-honor-wrap' id='pcHonor'>
          {rewardRender()}
          {renderAchieve()}
          {renderShare()}
          {/* 侧边导航 */}
          <div className='pc-honor-slideNavs'>
            <div
              className={classnames(
                'pc-honor-slideNav',
                navId == 0 && 'nav-active'
              )}
              onClick={() => handleNavClick(0)}
            >
              道具奖励
            </div>
            <div
              className={classnames(
                'pc-honor-slideNav',
                navId == 1 && 'nav-active'
              )}
              onClick={() => handleNavClick(1)}
            >
              成就图
            </div>
          </div>
        </div>
      </div>
    </LayoutDesktop>
  );
};

export const DesktopHonors = () => {
  const { id } = useParams();

  const setHonorsInfo = useSetRecoilState(honorsInfoState);

  // const [medalRenewed, setMedalRenewed] = useRecoilState(medalRenewedState)

  const { state, contents } = useRecoilValueLoadable<HonorsInfoModel>(
    fetchHonorsInfoState(id ?? '')
  );

  const refresh = useRecoilRefresher_UNSTABLE(fetchHonorsInfoState(id ?? ''));

  useEffect(() => {
    if (state === 'hasValue') {
      setHonorsInfo(contents);

      // const showFirstAchieveList = contents.achieve_list.filter((item) => {
      //   return item.is_show_first_achieve === 1
      // })

      // if (showFirstAchieveList.length > 0) {
      //   setMedalRenewed(true)
      // } else {
      //   setMedalRenewed(false)
      // }

    }
  }, [state]);

  switch (state) {
    case 'hasValue':
      return <HonorsPage />;
    case 'hasError':
      return (
        <ErrorPage
          message={contents.message}
          onRetry={() => {
            refresh();
          }}
        />
      );
    case 'loading':
      return <DefaultLoadingPage />;
  }
};
